import { Stack } from "@mantine/core";
import { SystemEmailModeConfirmModel } from "./systemEmailModeConfirmModel";
import { SystemEmailModeDescription } from "./SystemEmailModeDescription";
import { SystemEmailModeError } from "./SystemEmailModeError";
import { SystemEmailModeConfirmActions } from "./SystemEmailModeConfirmActions";

export function SystemEmailModeConfirmContent({
  model,
}: {
  model: SystemEmailModeConfirmModel;
}) {
  return (
    <Stack>
      <SystemEmailModeDescription
        emailLabel={model.emailLabel}
        mode={model.mode}
      />
      <SystemEmailModeError error={model.error} />
      <SystemEmailModeConfirmActions model={model} />
    </Stack>
  );
}
